import {
  getCustomerTicketTabStatus,
  postCustomerTicketTabStatus,
} from "@/api/customerTicket";
import { useLoadingStore } from "@/stores/loading";
import { useEffect, useState } from "react";
import { TabStatus } from "./types";

type Status = {
  id: number;
  data_id: number;
  tab_statuses_id: number;
};

export const StatusSelect = ({
  dataId,
  getTicket,
}: {
  dataId: number;
  getTicket: () => void;
}) => {
  const [options, setOptions] = useState<Omit<TabStatus, "count">[]>([]);
  const [status, setStatus] = useState<Status | null>(null);
  const setLoading = useLoadingStore((state) => state.setLoading);

  const onChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLoading(true);
    await postCustomerTicketTabStatus(dataId, Number(e.target.value));
    getTicket();
    setLoading(false);
  };

  useEffect(() => {
    getCustomerTicketTabStatus(dataId).then((res) => {
      setOptions(res.data.options);
      setStatus(res.data.status);
    });
  }, [dataId]);

  if (!status || options.length === 0) return null;

  return (
    <select
      defaultValue={status.tab_statuses_id}
      onChange={onChange}
      className="customer-ticket-status-select"
    >
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.code}:{option.status}
        </option>
      ))}
    </select>
  );
};
